export enum EmbeddedNotificationTypeEnum {
	INFORMATION = 'information',
	SUCCESS = 'success',
	ERROR = 'error',
	WARNING = 'warning'
}